export default __webpack_public_path__ + "static/media/Coverage_purple.d850f4e2.svg";